import React from "react";

const Cube: React.FC = () => {
    return (
        <>
            <div className="scene --fadeincube">
                <div className="cube__outter">
                    <div className="cube__face cube__face--front">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--back">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--right">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--left">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--top">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--bottom">
                        <div className="cube__face"></div>

                    </div>
                </div>
            </div>

            <div className="scene --fadeincube">
                <div className="cube__inner">
                    <div className="cube__face cube__face--front">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--back">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--right">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--left">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--top">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--bottom">
                        <div className="cube__face"></div>

                    </div>
                </div>
            </div>

            <div className="scene --fadeincube">
                <div className="cube__inner__inner">
                    <div className="cube__face cube__face--front">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--back">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--right">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--left">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--top">
                        <div className="cube__face"></div>

                    </div>
                    <div className="cube__face cube__face--bottom">
                        <div className="cube__face"></div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Cube;